import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: []
}

export const machineSlice = createSlice({
  name: 'machineSliceName',
  initialState,
  reducers: {
    addMachine: () => {
    },
    getMachine: () => {
    },
    updateMachine: () => {
    },
    successMachine: (state, action) => {
      state.data = action.payload
    },
    failedMachine: () => {
    }
  },
})

export const { addMachine, getMachine, updateMachine, successMachine, failedMachine } = machineSlice.actions

export default machineSlice.reducer
